import { Box, BoxProps, Heading, Text } from "@vinomofo/components";
import styled from "styled-components";
import { COLORS } from "../../styles";
import { UrgencyMessage } from "../../types";

export interface OfferCtaMessageProps extends BoxProps {
  message: UrgencyMessage;
  isTierEligible?: boolean;
  isSpirit?: boolean;
  showCountdown?: boolean;
  isSoldOut?: boolean;
}

const StyledText = styled(Text)<{ showCountdown: boolean; isSpirit: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 480px) {
    ${({ showCountdown, isSpirit }) =>
      showCountdown &&
      isSpirit &&
      `
        width: 70px;
        text-align: left;
    `}
  }
`;

const VimExclusiveLabel = ({ isSpirit, showCountdown, isSoldOut }: OfferCtaMessageProps) => (
  <Box
    mb={0}
    p="4px"
    display="flex"
    justifyContent={isSpirit && showCountdown && !isSoldOut ? "left" : "center"}
  >
    <Heading
      as="span"
      variant="xxs"
      color="mofoPrimary"
      lineHeight="none"
      fontWeight={900}
      fontSize="12px"
    >
      VIM
    </Heading>
    <Heading
      as="span"
      variant="xxs"
      color="white"
      lineHeight="none"
      fontWeight={100}
      fontSize="12px"
    >
      &nbsp; Exclusive
    </Heading>
  </Box>
);

export const OfferCtaMessage = ({
  message,
  isTierEligible,
  isSpirit = false,
  showCountdown = false,
  isSoldOut = false,
  ...rest
}: OfferCtaMessageProps): JSX.Element => {
  const baseProps = {
    px: "10px",
    ...rest,
  };

  if (isTierEligible) {
    return (
      <Box bg={COLORS.black} {...baseProps} style={{ justifyContent: "center" }}>
        <VimExclusiveLabel
          isSpirit={isSpirit}
          showCountdown={showCountdown}
          isSoldOut={isSoldOut}
          message={message}
        />
      </Box>
    );
  }

  const bgColor = message?.backgroundColor
    ? COLORS[message.backgroundColor] ?? message.backgroundColor
    : undefined;

  return (
    <Box bg={bgColor} {...baseProps} padding={["3px 10px", "3px 15px"]}>
      <StyledText
        textAlign={isSpirit && showCountdown && !isSoldOut ? "left" : "center"}
        fontSize={["12px", "13px"]}
        fontWeight={600}
        color={message.textColor ?? "white"}
        fontFamily="heading"
        showCountdown={showCountdown}
        isSpirit={isSpirit}
      >
        {message?.description}
      </StyledText>
    </Box>
  );
};
